import Dispatcher from "Dispatcher";
import TreeItemTypes from "./TreeItemTypes";
import ContextedReduceStore from "./util/ContextedReduceStore";
import typeCheckingStore from "data/util/typeCheckingStore";
import PropTypes from "prop-types";

export const setExpandNode = (ctx, key, expand) => {
    if (expand && isExpanded(ctx, key)) {
        return ctx; // already expanded
    }
    if (! expand && ! isExpanded(ctx, key)) {
        return ctx; // already collapsed
    }
    // noinspection EqualityComparisonWithCoercionJS
    return {
        ...ctx,
        itemOverrides: ctx.expandAll == expand
            ? ctx.itemOverrides.filter(it => it !== key)
            : ctx.itemOverrides.concat(key),
    };
};

export const setExpandAll = (ctx, expandAll) =>
    ctx.expandAll === expandAll && ctx.itemOverrides.length === 0 ? ctx : {
        ...ctx,
        expandAll,
        itemOverrides: [], // clear per-item state
    };

export const isExpanded = (ctx, key) =>
    ctx.expandAll
        ? ctx.itemOverrides.indexOf(key) < 0
        : ctx.itemOverrides.indexOf(key) >= 0;

export const isExpandAll = ctx =>
    ctx.expandAll;

class TreeItemStore extends ContextedReduceStore {
    constructor() {
        super(Dispatcher);
    }

    getInitialContext() {
        return {
            expandAll: true,
            itemOverrides: [],
        };
    }

    reduceContext(ctx, action) {
        switch (action.type) {
            case TreeItemTypes.COLLAPSE_ALL:
                return setExpandAll(ctx, false);
            case TreeItemTypes.EXPAND_ALL:
                return setExpandAll(ctx, true);
            case TreeItemTypes.COLLAPSE_OR_EXPAND:
                return setExpandNode(ctx, action.key, ! isExpanded(ctx, action.key));
            default:
                return ctx;
        }
    }

    isExpandAll(contextId) {
        return isExpandAll(this.getState(contextId));
    }

    isExpanded(contextId, key) {
        return isExpanded(this.getState(contextId), key);
    }

    getExpandedTest(contextId) {
        const ctx = this.getState(contextId);
        return key => isExpanded(ctx, key);
    }
}

TreeItemStore.contextTypes = {
    expandAll: PropTypes.bool.isRequired,
    // this should be a Set, but Node doesn't JSON.stringify correctly
    itemOverrides: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default typeCheckingStore(new TreeItemStore());



// WEBPACK FOOTER //
// ./app/data/TreeItemStore.js